import { useState } from 'react';
import { tapFeedbackSubtle, zikrDoneFeedback } from '../../telegram/haptics';
import { ru } from '../../strings/ru';
import styles from './SalawatCounter.module.css';

/**
 * Круг заполняется по сотне и начинается заново — это не цель, которую
 * надо «взять», а привычная по чёткам отметка круга. Салават читают
 * сколько получится, поэтому фиксированной кратности у него нет.
 */
const LAP = 100;

interface Props {
  today: number;
  onTap: () => number;
}

export function SalawatCounter({ today, onTap }: Props) {
  const [pulse, setPulse] = useState(0);

  const inLap = today % LAP;
  const laps = Math.floor(today / LAP);
  const progress = inLap / LAP;

  function handleTap() {
    const next = onTap();

    // Визуальный отклик обязателен: хаптика на десктопе и в вебе — no-op
    setPulse((p) => p + 1);

    // Счёт салавата уходит в сотни, поэтому обычный impact на каждом тапе
    // утомляет. Заметная отдача — только на круглой сотне.
    if (next % LAP === 0) zikrDoneFeedback();
    else tapFeedbackSubtle();
  }

  const R = 54;
  const circumference = 2 * Math.PI * R;

  return (
    <div className={styles.wrap}>
      <button
        className={styles.target}
        onClick={handleTap}
        aria-label={`${ru.salawat.tapToCount}. ${ru.salawat.today}: ${today}`}
      >
        <span key={pulse} className={styles.ripple} aria-hidden="true" />

        <svg className={styles.ring} viewBox="0 0 128 128" aria-hidden="true">
          <circle
            className={styles.ringTrack}
            cx="64"
            cy="64"
            r={R}
            fill="none"
            strokeWidth="6"
          />
          <circle
            className={styles.ringFill}
            cx="64"
            cy="64"
            r={R}
            fill="none"
            strokeWidth="6"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference * (1 - progress)}
            transform="rotate(-90 64 64)"
          />
        </svg>

        <span className={styles.label}>
          <span className={styles.count}>{today}</span>
          {laps > 0 && (
            <span className={styles.laps}>
              {laps} × {LAP}
            </span>
          )}
        </span>
      </button>

      <p className={styles.hint}>{ru.salawat.tapToCount}</p>
    </div>
  );
}
